import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة اللتر - تحويل وحدة قياس اللتر كم يساوي (لتر، مل، جالون، م³)";
const DESCRIPTION = "حاسبة اللتر للتحويل بين وحدات الحجم المختلفة! اكتشف اللتر كم يساوي من ملليلتر (مل)، جالون، متر مكعب (م³)، سم³ وغيرها. أداة دقيقة وسريعة لتحويل اللترات بسهولة.";
const KEYWORDS = "حساب اللتر, اللتر, اللتر لقياس, اللتر وحدة قياس, اللتر كم يساوي, تحويل اللتر, حاسبة لتر, لتر إلى مل, لتر إلى جالون, لتر إلى متر مكعب, وحدة قياس الحجم, تحويل وحدات الحجم, كم لتر في الجالون, حاسبة تحويل السوائل, تحويل ml إلى لتر";
const OG_URL = "https://do-calculate.com/calculator/ar/liter-calculator/";
function LitreCalculator() {
  const [inputValue, setInputValue] = useState("");
  const [fromUnit, setFromUnit] = useState("ml");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const unitOptions = [
    { value: "ml", label: "ملليلتر (مل)" },
    { value: "cm3", label: "سنتيمتر مكعب (سم³)" },
    { value: "m3", label: "متر مكعب (م³)" },
    { value: "gal", label: "جالون" },
    { value: "liter", label: "لتر" }
  ];
  const conversionRates = {
    ml: 0.001,
    cm3: 0.001,
    m3: 1000,
    gal: 3.78541,
    liter: 1
  };
  const handleCalculate = () => {
    try {
      if (!inputValue || isNaN(inputValue)) {
        throw new Error("الرجاء إدخال قيمة صحيحة");
      }
      const value = parseFloat(inputValue);
      const convertedValue = value * conversionRates[fromUnit];
      setResult(convertedValue.toFixed(4));
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هل تحتاج إلى تحويل وحدات الحجم المختلفة إلى لترات أو العكس؟ حاسبتنا
                  الذكية تقوم بتحويل بين اللتر والملليلتر والجالون والمتر المكعب وغيرها
                  من وحدات قياس الحجم بدقة وسهولة.
                </p>
                <p>
                  اختر الوحدة التي تريد التحويل منها، أدخل القيمة، ثم اضغط على "احسب"
                  لتحصل على النتيجة فوراً.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="value">
                        أدخل القيمة
                      </label>
                      <input
                        id="value"
                        type="number"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="أدخل القيمة"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group mt-3">
                      <label className="form-label ms-2" htmlFor="unit">
                        اختر وحدة القياس
                      </label>
                      <select
                        id="unit"
                        value={fromUnit}
                        onChange={(e) => setFromUnit(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        {unitOptions.map((unit) => (
                          <option key={unit.value} value={unit.value}>
                            {unit.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">
                        {inputValue} {unitOptions.find(u => u.value === fromUnit).label} = {result} لتر
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      حاسبة تحويل وحدات الحجم (اللتر)
                    </h2>
                  </u>
                  <p>
                    هذه الحاسبة تمكنك من التحويل بين وحدات قياس الحجم المختلفة:
                  </p>
                  <ul>
                    <li>1 لتر = 1000 ملليلتر (مل)</li>
                    <li>1 لتر = 1000 سنتيمتر مكعب (سم³)</li>
                    <li>1 لتر ≈ 0.264 جالون</li>
                    <li>1 متر مكعب (م³) = 1000 لتر</li>
                  </ul>
                  <div className="p-3 mb-2 bg-info">
                    مثال: لتحويل 500 مل إلى لتر، اختر "ملليلتر" وأدخل 500. النتيجة: 0.5 لتر
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيفية استخدام حاسبة اللتر
                    </h2>
                  </u>
                  <ol>
                    <li>اختر الوحدة التي تريد التحويل منها</li>
                    <li>أدخل القيمة المراد تحويلها</li>
                    <li>اضغط على زر "احسب"</li>
                    <li>ستظهر النتيجة باللترات</li>
                  </ol>
                  <p>
                    يمكنك استخدام هذه الحاسبة للتحويل بين جميع وحدات الحجم الشائعة
                    بسهولة وسرعة.
                  </p>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default LitreCalculator;